import { usePermissionRequest } from '@dealstack/frontend/shared/components/PermissionWrapper/PermissionWrapper';
import {
	PermissionRole,
	ResourceType,
} from '@dealstack/shared/lib/common/fineGrainedAuthorization/permissions';
import { EmailTemplateScope } from '@dealstack/frontend/shared/components/EmailTemplates/EmailTemplates.types';

const EDIT_PERMISSION = {
	deal: { resourceType: ResourceType.DEAL, permissionRole: PermissionRole.EDITOR },
	programme: { resourceType: ResourceType.PROGRAMME, permissionRole: PermissionRole.ADMIN },
	organization: { resourceType: ResourceType.ORGANIZATION, permissionRole: PermissionRole.ADMIN },
	organizationDeal: {
		resourceType: ResourceType.ORGANIZATION,
		permissionRole: PermissionRole.ADMIN,
	},
} as const;

/**
 * Mirrors the controllers: reading takes VIEWER everywhere, editing takes EDITOR on a deal and
 * ADMIN on a programme or organisation, so a viewer is not invited to write an email the save
 * would refuse.
 */
export const useEmailTemplateAccess = (scope: EmailTemplateScope): { canEdit: boolean } => {
	const { hasPermission: canEdit } = usePermissionRequest({
		...EDIT_PERMISSION[scope.kind],
		resourceId: scope.id,
	});

	return { canEdit };
};
